module.exports = __webpack_public_path__ + "media/images/products/products/b4-c747915719795014b7dbddff88744da4.jpg";